import AgentPhonePreferences from 'models/agent_phone_preferences';
import AgentVoiceConfiguration from 'models/agent_voice_configuration';
import PutUserBase from './put_user_base';

export default class UpdateUser extends PutUserBase {
  runAction(editableUser) {
    let agentProfile = this.context.stores.agentProfiles.find(editableUser.id);
    let voiceConfiguration = agentProfile.voiceConfiguration;

    let appFeatures = this.context.stores.appFeatures.get();
    if (appFeatures.isEnabled('telephonyApi') || appFeatures.isEnabled('sip')) {
      let defaultPhonePreference = appFeatures.isEnabled('webRTC')
        ? AgentPhonePreferences.BROWSER
        : AgentPhonePreferences.NONE;

      voiceConfiguration = AgentVoiceConfiguration.create({
        stationId: editableUser.stationId,
        preference: editableUser.stationId ? AgentPhonePreferences.STATION : defaultPhonePreference,
      });
    }

    let user = this.context.stores.users.find(editableUser.id);
    let disabledAt = user.disabledAt;
    if (!user.isDisabled() && editableUser.disabled) {
      disabledAt = new Date().toISOString();
    } else if (user.isDisabled() && !editableUser.disabled) {
      disabledAt = null;
    }

    let agentUserAttrs = {
      ...editableUser,
      disabledAt,
      username: editableUser.email,
      voiceConfiguration: voiceConfiguration && voiceConfiguration.toJs(),
    };
    this.context.gateways.agentUser.update(editableUser.id, agentUserAttrs);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/update_user.js